import axios from "axios";

export default function makeAxios(oauth2Service, snackbarService, args = {}) {
    const created = axios.create(args);

    created.interceptors.request.use(function (config) {
        return oauth2Service.withAccessToken().then(bearer => {
            config.headers["Authorization"] = `Bearer ${bearer}`;
            config.withCredentials = true;
            return config;
        }).catch(snackbarService.catchOAuth2SessionError());
    });

    return created;
}
